const Events = {
  LOGIN_SUCCESS: 'Login success',
  LOGIN_FAILED: 'Login failed',
  LOGOUT_SUCCESS: 'Logout Success',
  LOGOUT_FAILED: 'Logout failed',
  RETRIEVED_PERMISSIONS: 'Retrieved Permissions',
  PERMISSIONS_FAILED: 'Failed to retrieve permissions',
  RETRIEVED_USER_INFO: 'Retrieved user info',
  RESET_PASSWORD_SUCCESS: 'Reset password success',
  RESET_PASSWORD_FAILED: 'Reset password failed',
  CHANGE_PASSWORD_SUCCESS: 'Change password success',
  CHANGE_PASSWORD_FAILED: 'Change password failed',
  RESET_IS_PASSWORD_CHANGED: 'Reset isPasswordChanged',
  CREATE_SALESFORCE_SUCCESS: 'Create Salesforce success',
  CREATE_SALESFORCE_FAIL: 'Create Salesforce failed'
};

export default Events;
